import { FintrafficStyle } from "./FintrafficStyle";
export default FintrafficStyle;
